export const getAvailableColumns = (state) => state.reportTemplateEditor.availableColumns
export const getSelectedColumns = (state) => state.reportTemplateEditor.selectedColumns
